


export default function Description() {
    return (
        <div className="bg-background py-24">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <h2 className='text-white text-2xl not-italic font-medium leading-9 font-title'>About Event</h2>
                <div className="mx-auto mt-8 max-w-2xl lg:max-w-none">
                    <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-3">
                        <div className="flex">
                            <dt className="text-base not-italic font-text leading-6 text-white">
                                <p className='my-2'>Consensus is the world's largest, longest-running and most influential gathering that brings together all sides of the cryptocurrency, blockchain and Web3 community.</p>

                                <p className='my-2'>From hard-hitting conversations with visionary speakers to hands-on workshops aimed at solving industry challenges, developers, investors, founders, brands, policymakers and more will walk away with the tools and insights needed to continue laying the foundation of a more decentralized future. </p>

                               
                            </dt>

                        </div>
                        <div className="flex">
                            <dt className="text-base not-italic font-text leading-6 text-white">

                                <p className='my-2'>Consensus is the world's largest, longest-running and most influential gathering that brings together all sides of the cryptocurrency, blockchain and Web3 community.</p>

                                <p className='my-2'>From hard-hitting conversations with visionary speakers to hands-on workshops aimed at solving industry challenges, developers, investors, founders, brands, policymakers and more will walk away with the tools and insights needed to continue laying the foundation of a more decentralized future. </p>

                              
                            </dt>

                        </div>
                        <div className="flex">
                            <dt className="text-base font-semibold leading-7 text-white">
                                <p className="ml-10 my-2">Tickets Sold</p>
                                <p className="text-6xl not-italic font-bold ml-12 my-10 text-blue leading-10">1,473/6000</p>
                            </dt>

                        </div>
                    </dl>
                </div>
            </div>
        </div>
    )
}